import React from 'react';
import Text from './base';

const H1Alt = props => <Text defaultTag="h1" variant="h1Alt" {...props} />;

export default H1Alt;
